// @flow

import * as React from 'react';
import { bind } from '@ta/common.api';
import { localize } from '@ta/common.i18n';
import { TitleBar } from '@ta/modal.headers';
import { LoadingSpinner } from '@ta/styleguide.loading';
import PosRegion from './PosRegion';
import type { PosSelections } from './types';
import styles from './PosOverlayContents.less';

type Props = {
  apiResponse: {
    loading: boolean,
    data: ?PosSelections,
  },
  showHeader: boolean,
  currentLocale: string,
};

const PosOverlayContents = ({ apiResponse, showHeader, currentLocale }: Props) => (
  <div className={styles.overlayContents}>
    {showHeader ? (
      <TitleBar>
        {localize('footer_region')}
        {/* Regions */}
      </TitleBar>
    ) : null}
    {apiResponse.loading ? (
      <div className={styles.loaderWrap}>
        <LoadingSpinner />
      </div>
    ) : (
      <ul className={styles.posRegions}>
        {apiResponse.data &&
          apiResponse.data.regions.map(region => (
            <PosRegion region={region} key={region.region} currentLocale={currentLocale} />
          ))}
      </ul>
    )}
  </div>
);

const ApiBinding = bind<Props, {||}, _, _, _, _>((state, stage) => {
  const { initialServletName } = state.meta;
  const { locale } = state.i18n;

  const paramMap = {
    servlet: initialServletName || '',
    locale,
  };

  const searchParams = new URLSearchParams(paramMap);
  const url = `/data/1.0/pos/list?${searchParams.toString()}`;

  const apiCall = stage(url);

  return newState => ({
    apiResponse: apiCall.get(),
    showHeader: newState.meta.device.viewportCategory === 'MOBILE',
    currentLocale: newState.i18n.locale,
  });
})(PosOverlayContents);

export default ApiBinding;
